import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class DeliveriesTableSubsetCtrl implements IController {
  services: any;
  isMultiSelect: any;
  selectedIds: any;
  showProNumberColumn: boolean = false;
  selectedIdsChanged: Function;

  private selectedKeys: any;
  private expandedKeys: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.selectedKeys = {};
    this.expandedKeys = {};

    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });

    if (_.isUndefined(this.isMultiSelect)) {
      this.isMultiSelect = true;
    }
  }

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.$onInit();
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  toggleDelivery(serviceId) {
    if (!this.isMultiSelect) {
      this.selectedKeys = {};
    }

    this.selectedKeys[serviceId] = !this.selectedKeys[serviceId];
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return key;
    });
    this.selectedIdsChanged({selectedIds: _.compact(selectedIds)});
  }

  onToggleSelectAll() {

    const selectedIds = (!!this.services.length && (this.selectedIds.length !== this.services.length)) ?
      this.services.map(s => s.id) : [];

    this.selectedIdsChanged({selectedIds: _.compact(selectedIds)});
  }

  onExpand(serviceId) {
    this.expandedKeys[serviceId] = !this.expandedKeys[serviceId];
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesTableSubset', {
    bindings: {
      services: '<',
      isMultiSelect: '<?',
      selectedIds: '<',
      selectedIdsChanged: '&'
    },
    template: require('./deliveries-table-subset.html').default,
    controller: DeliveriesTableSubsetCtrl
  });
